import { ClubDetail } from "@nls-2022/nls-api";
export type BlogGenericContentType = {
  season: string;
  isPublished: boolean;
  pubDate: string;
  modifiedDate: string;
  title: string;
  excerpt: string;
  categories: Array<string>;
  content: string;
};

export type BlogContentType = BlogGenericContentType & {
  createDate: string;
  modifiedDate: string;
};

export type SponsorType = {
  sponsorName: string;
  sponsorUrl: string;
  sponsorIconUrl: string;
};

export type BlogClubBasicDetailsType = {
  clubName: string;
  clubUrl: string;
  step: string | null;
  leagueName: string | null;
};
export type MatchDetailsType = {
  homeClub: BlogClubBasicDetailsType;
  awayClub: BlogClubBasicDetailsType;
};

export enum FACompType {
  FACup,
  FATrophy,
  FAVase,
}

export type FACompReferenceType = {
  comp: FACompType;
  name: string;
  sponsorName: string;
  categories: Array<string>;
};

export type FACompBlogContentType = BlogGenericContentType & FACompDetailsType;
export type FACompResultBlogContentType = BlogGenericContentType &
  FACompResultDetailsType;

export type FACompDetailsType = {
  season: string;
  comp: FACompType;
  roundName: string;
  roundDate: string;
  noOfTies: number;
  winnerPrizeMoney: number;
  loserPrizeMoney: number | null;
  matchList: Array<MatchDetailsType> | null;
  otherText: string;
};

export type FACompResultDetailsType = {
  season: string;
  comp: FACompType;
  clubs: Array<string>;
  winningClub: string;
  losingClub: string;
  score: string;
  aet: boolean;
  pens: boolean;
  winningClubDetail: ClubDetail | null | undefined;
  losingClubDetail: ClubDetail | null | undefined;
};

export type FACompsBySeasonType = {
  season: string;
  compDetailsList: Array<FACompDetailsType>;
};

export type FACompsResultBySeasonType = {
  season: string;
  compDetailsList: Array<FACompResultDetailsType>;
};

export type FACompCurrentRoundsType = {
  comp: FACompType;
  roundNames: Array<string>;
};
